import { IFormReadonlyModelAccessor } from "../../Form/IFormModelAccessor";
import { IDigestApiClient } from "../../../../../Common/CandyApiClient/DigestApiClient/IDigestApiClient";
import { AbsoluteModelPath, createAbsoluteFromMask, PathTokens } from "../../../../../Common/ModelPath/ModelPath";

import { IPicklistsProvider, PicklistSourceId } from "./IPicklistsProvider";
import { IPicklist } from "./IPicklist";
import { DigestApiPicklist } from "./DigestApiPicklist";
import { InnerPathsPicklist } from "./InnerPathsPicklist";

export class PicklistsProvider implements IPicklistsProvider {
    private readonly modelAccessor: IFormReadonlyModelAccessor;
    private readonly digestApiClient: IDigestApiClient;
    private readonly digestApiPicklists = new Map<string, DigestApiPicklist>();
    private readonly innerPathsPicklists = new Map<string, InnerPathsPicklist>();

    public constructor(digestApiClient: IDigestApiClient, modelAccessor: IFormReadonlyModelAccessor) {
        this.digestApiClient = digestApiClient;
        this.modelAccessor = modelAccessor;
    }

    public getDigestApiPicklist(gId: string): IPicklist {
        return getOrSet(this.digestApiPicklists, gId, () => new DigestApiPicklist(this.digestApiClient, gId));
    }

    public getInnerPathsPicklist(paths: readonly AbsoluteModelPath[]): IPicklist {
        return getOrSet(
            this.innerPathsPicklists,
            paths.map(x => x.toString()).join(""),
            () => new InnerPathsPicklist(this.modelAccessor, paths)
        );
    }

    public getPicklist(source: PicklistSourceId): IPicklist | undefined {
        if (source.gId) {
            return this.getDigestApiPicklist(source.gId);
        } else if (source.gPaths != undefined) {
            const paths = source.gPaths.map(x => createAbsoluteFromMask(x, PathTokens.each));
            return this.getInnerPathsPicklist(paths);
        }
        return undefined;
    }
}

function getOrSet<K, V>(map: Map<K, V>, key: K, initValueFactory: () => V): V {
    const result = map.get(key);
    if (result != undefined) {
        return result;
    }
    const newResult = initValueFactory();
    map.set(key, newResult);
    return newResult;
}
